<template lang="pug">
v-dialog(v-model='active' max-width="375px" content-class="confirmDialog")
  v-card
    v-card-title {{ state.title }}
    v-card-text.confirmText {{ state.content }}
    v-card-actions
      v-spacer
      v-btn(:color="state.cancelColor" text @click='onClick(false)') {{ state.cancelText }}
      v-btn(:color='state.okColor' text @click='onClick(true)')  {{ state.okText }}
          
</template>

<script>
export default {
  data() {
    return {
      state: {
        title: '執行確認',
        content: '確定後無法更改，確定要執行嗎?',
        okText: '確定',
        cancelText: '取消',
        cancelColor: '',
        okColor: '',
      },
      active: false,
      onClick: null,
    };
  },
  methods: {
    open(config) {
      Object.assign(this.state, config)
      this.active = true;
      return new Promise((resolve) => {
        this.onClick = (value) => {
          resolve(value);
          this.active = false;
        };
      });
    },
  }
};
</script>
<style lang="scss">
.confirmDialog .v-card .confirmText {
  font-size: 16px;
  white-space: pre-line !important;
}
</style>